<template>
  <div>
    <template v-for="(data, index) in dataForm">

      <!-- SIMPLE INPUT -->

      <simple-input v-if="data.dataType === 'input'" :key="'input-' + index" :data="data" :validation="validation" :disabled="disabled"></simple-input>

      <!-- DOUBLE INPUT -->
      
      <double-input v-if="data.dataType === 'input-double'" :key="'input-' + index" :data="data" :validation="validation" :disabled="disabled"></double-input>

      <!--SELECT INPUT-->

      <select-input v-if="data.dataType === 'select'" :key="'select-' + index" :data="data" :locations="locations" :banks="banks" :bankAccountTypes="bankAccountTypes" :validation="validation" :disabled="disabled"></select-input>

      <!--UPLOADS-->

      <el-row v-if="data.dataType === 'upload'" :key="'upload-' + index">
        <el-col :span="8" style="marginbottom: 25px">
            <pdf-file
              v-bind:pdfFilePath.sync="data.model"
              :habModificaPdf="habModificaPdf"
              :titulo="data.label"
              :id="data.label"
              :prop="data.name"
              :country="'PER'"
              :disabled="disabled"
                      />
        </el-col>
        <el-alert v-if="verifyFields (data, validation)" :title="`Falta completar: ${data.label}`" type="error" class="message-warning" :closable="false"/>
      </el-row>

      <!--SWITCH-Perception-->

      <switch-perception :key="'switch-perception' + index" v-if="data.dataType === 'switch-perception'" :data="data" :validation="validation" :disabled="disabled" />

      <!-- SWITCH-retention -->

      <switch-retention v-if="data.dataType === 'switch-retention'" :key="'switch-retention' + index" :data="data" :denominaciones="denominaciones" :validation="validation" :disabled="disabled" />

      <!--SWITCH-detraction-->
      <switch-detraction v-if="data.dataType === 'switch-detraction'" :key="'switch-detraction' + index" :data="data" :validation="validation" :disabled="disabled" />
      
    </template>
  </div>
</template>

<script>
import PdfFile from '../PdfFile.vue'
import SimpleInput from './SimpleInput.vue'
import DoubleInput from './DoubleInput.vue'
import SelectInput from './SelectInput.vue'
import SwitchPerception from './SwitchPerception.vue'
import SwitchRetention from './SwitchRetention.vue'
import SwitchDetraction from './SwitchDetraction.vue'
import { verifyFields } from '../helpers/utils.js'
export default {
  components: {
    'pdf-file': PdfFile,
    'simple-input': SimpleInput,
    'double-input': DoubleInput,
    'select-input': SelectInput,
    'switch-perception': SwitchPerception,
    'switch-retention': SwitchRetention,
    'switch-detraction': SwitchDetraction
  },
  data () {
    return {
      habModificaPdf: true
    }
  },
  props: {
    dataForm: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locations: {
      type: [Array, Object]
    },
    banks: {
      type: [Array, Object]
    },
    bankAccountTypes: {
      type: [Array, Object]
    },
    denominaciones: {
      type: [Array, Object]
    }
  },
  computed: {},
  methods: {
    verifyFields
  }
}
</script>
<style>
  .switch-box{
    width: 100%;
    font-size: 14px;
    font-weight: lighter;
    color: #7b818c;
    display: flex;
    flex-direction:column;
    align-items: flex-start;
  }

  .message-warning{
    width: 400px;
    height: 40px;
    margin-left: 45px;
    font-weight: bold;
  }

  .input-warning{
    margin-bottom: 10px;
    border: 1px solid red;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// AltaFormElements.vue?436d83f0